var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlayBg = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 6.9375H12.1875V1.875C12.1875 0.841125 11.3464 0 10.3125 0H1.875C0.841125 0 0 0.841125 0 1.875V10.3125C0 11.3464 0.841125 12.1875 1.875 12.1875H6.9375V14.4375C6.9375 15.2991 7.63844 16 8.5 16H14.4375C15.2991 16 16 15.2991 16 14.4375V8.5C16 7.63844 15.2991 6.9375 14.4375 6.9375ZM6.9375 8.5V10.9375H1.875C1.53038 10.9375 1.25 10.6571 1.25 10.3125V1.875C1.25 1.53038 1.53038 1.25 1.875 1.25H10.3125C10.6571 1.25 10.9375 1.53038 10.9375 1.875V6.9375H8.5C7.63844 6.9375 6.9375 7.63844 6.9375 8.5ZM14.75 14.4375C14.75 14.6098 14.6098 14.75 14.4375 14.75H8.5C8.32769 14.75 8.1875 14.6098 8.1875 14.4375V8.5C8.1875 8.32769 8.32769 8.1875 8.5 8.1875H14.4375C14.6098 8.1875 14.75 8.32769 14.75 8.5V14.4375Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54353 4.0882C5.24336 3.88134 5 4.0508 5 4.46639V7.53329C5 7.94931 5.24336 8.11856 5.54353 7.91189L7.77479 6.37457C8.07507 6.16764 8.07507 5.83238 7.77479 5.6255L5.54353 4.0882Z",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlayBg, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play-bg.eb5f6a16.svg";
export { ForwardRef as ReactComponent };